import * as React from "react";
import { ShopSearch } from "components/product-collection/product-collection-side-panel/product-collection-shop-search";
import { HEADER_HEIGHT } from "./shop-tool-panel";
import { Breadcrumbs } from "./breadcrumbs";
import { List } from "immutable";
import { Location } from "history";
import { RouterState } from "react-router";
import type { IScope } from "reducers/scope";
import { IDisplayFields } from "helpers/product-collection";

interface IProps {
    merchantId: string;
    onFetchGlobalProducts: (filters) => void;
    onFetchNextGlobalProducts: (params) => void;
    globalProducts: any;
    globalProductsIsFetching: boolean;
    globalProductNextPageQuery: any;
    itemsId: string;
    items: List<any>;
    onAddItem: (params) => void;
    brandEntities: any;
    location: Location;
    router: RouterState;
    scope: IScope;
    children: React.ReactNode;
    breadcrumbs: Array<{ displayName: string; path?: string }>;
    inAssortmentProducts: { [key: string]: string[] };
    collectionEditable: boolean;
    shopViewFields: IDisplayFields;
    itemDisplayProperty: List<any>;
}

export const Search: React.FunctionComponent<IProps> = ({
    merchantId,
    onFetchGlobalProducts,
    globalProducts,
    globalProductsIsFetching,
    globalProductNextPageQuery,
    onFetchNextGlobalProducts,
    items,
    itemsId,
    onAddItem,
    brandEntities,
    location,
    router,
    scope,
    children,
    breadcrumbs,
    inAssortmentProducts,
    collectionEditable,
    shopViewFields,
    itemDisplayProperty,
}) => {
    const breadcrumbsRef = React.useRef<HTMLDivElement>();
    return (
        <React.Fragment>
            <div className="shopHeader">{children}</div>
            <Breadcrumbs breadcrumbs={breadcrumbs} breadcrumbsRef={breadcrumbsRef} />
            <ShopSearch
                merchantId={merchantId}
                brandEntities={brandEntities}
                onFetchGlobalProducts={onFetchGlobalProducts}
                globalProducts={globalProducts}
                globalProductsIsFetching={globalProductsIsFetching}
                globalProductNextPageQuery={globalProductNextPageQuery}
                inAssortmentProducts={inAssortmentProducts}
                itemsId={itemsId}
                items={items}
                location={location}
                onAddItem={onAddItem}
                scope={scope}
                sidePanelWidth={null}
                router={router}
                collectionEditable={collectionEditable}
                onFetchNextGlobalProducts={onFetchNextGlobalProducts}
                params={router.params}
                shopViewFields={shopViewFields}
                overrideStyles={{
                    gridWidth: 320,
                    headerHeight: HEADER_HEIGHT + (breadcrumbsRef.current ? breadcrumbsRef.current.offsetHeight : 0),
                }}
                isSidePanel={true}
                itemDisplayProperty={itemDisplayProperty}
            />
        </React.Fragment>
    );
};
